import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from 'ng2-translate';

import { DashboardOverviewComponent } from './dashboard-overview.component';
import { CreateDashboardComponent } from './components/create-dashboard/create-dashboard.component';
import { DashboardDomainService } from '../domain/services/dashboard/dashboard.domain.service';

import { DashboardOverviewService } from './services/dashboard-overview.service';
import { DeleteDashboardComponent } from './components/delete-dashboard/delete-dashboard.component';
import { EditDashboardComponent } from './components/edit-dashboard/edit-dashboard.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    TranslateModule.forRoot()
  ],
  exports: [
    DashboardOverviewComponent
  ],
  providers: [
    DashboardOverviewService,
    DashboardDomainService
  ],
  declarations: [
    DashboardOverviewComponent,
    CreateDashboardComponent,
    DeleteDashboardComponent,
    EditDashboardComponent
  ]
})
export class DashboardOverviewModule { }



// WEBPACK FOOTER //
// ./src/app/modules/dashboard-overview/dashboard-overview.module.ts